/*eslint-disable no-process-env, no-undef */
// TODO: Handle newsletter opt-in
// TODO: Add Complete Actions to the Pardot form handler. Ask Rashida what tags to put there
// TODO: Have a spreadsheet with the various scenarios
// TODO: Finalize keyword research on what we want to go after

const qs = require('qs')
const { REACT_APP_API_BASE_URL, REACT_APP_LEAD_API_BASE_URL } = process.env

const ENDPOINTS = {
	saveLead: 'leads',
	noAccess: 'noaccess',
	invite: 'invite',
	adAccounts: 'adaccounts',
	adReport: 'accountReport',
	requestMonitor: 'request_monitor',
	unsubscribe: 'admonitor_unsubscribe',
	updateToken: 'admonitor/update_token',
	leadMagnet: 'request_report'
}

const reportError = (path, res, args = {}) => {
	window.mixpanel.track('[AdScore] - API Error', {
		baseUri: REACT_APP_API_BASE_URL,
		path,
		apiResponse: res,
		args: JSON.stringify(args)
	})
}

async function getRequest(endpoint, args = {}) {
	const path = REACT_APP_API_BASE_URL + endpoint + '?' + qs.stringify(args)
	const start = Date.now() / 1000
	try {
		const res = await fetch(path)
		if(res.status !== 200) {
			// It errored out
			reportError(path, res)
			return false
		}
		let body = await res.json()
		body.request_time = ((Date.now() / 1000) - start).toFixed(3)
		return body
	} catch(err) {
		reportError(path, {}, args)
		return false
	}
}

async function apiRequest(endpoint, args, baseUrl = REACT_APP_API_BASE_URL) {
	const start = Date.now() / 1000
	const path = baseUrl + endpoint
	try {
		const res = await fetch(path, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(args)
		})
		if(res.status !== 200) {
			reportError(path, res, args)
			// It errored out
			return false
		}
		let body = await res.json()
		body.request_time = ((Date.now() / 1000) - start).toFixed(3)
		if(body.status === 'OK') {
			return true
		} else {
			return false
		}
	} catch(err) {
		reportError(path, {}, args)
		return false
	}
	
}

export async function requestLeadMagnet({email, lead_magnet_id} = {}) {
	console.log('CALLING THE API')
	const res = await apiRequest(ENDPOINTS.leadMagnet, {email, lead_magnet_id}, REACT_APP_LEAD_API_BASE_URL)
	console.log('CALLED THE API: ', res)
	return res
}

export async function subscribe({email, firstName, accountId, token, accountName} = {}) {
	const res = await apiRequest(ENDPOINTS.requestMonitor, {email, accountId, token, accountName, firstName})
	return res
}

export async function saveLead(email, traffic_source, paid_traffic_source) {
	const res = await apiRequest(ENDPOINTS.saveLead, {email, traffic_source, paid_traffic_source})
	return res
}

export async function updateContact(fields) {
	Object.keys(fields).forEach(key => (fields[key] === undefined || fields[key] === '') ? delete fields[key] : '')
	const res = await apiRequest(ENDPOINTS.saveLead, fields)
	return res
}

export async function updateToken(email, token) {
	const res = await apiRequest(ENDPOINTS.updateToken, {email, token})
	return res
}

export async function sendInvite(recipient, from) {
	const res = await apiRequest(ENDPOINTS.invite, {recipient, from})
	return res
}

export async function noAccess(fields) {
	const res = await apiRequest(ENDPOINTS.noAccess, fields)
	return res
}

export async function adAccounts(token, email) {
	const res = await getRequest(ENDPOINTS.adAccounts, {token, email})
	if(res) { return res }
	else { return {'status': 'FAIL', 'accounts': []} }
}

export async function fetchReport(accountId, token, email, account_name) {
	const res = await getRequest(ENDPOINTS.adReport, {accountId, token, email, account_name})
	return res
}

export async function unsubscribe(adAccountId, unsubscribeToken) {
	const args = {adAccountId, unsubscribeToken}
	const res = await getRequest(ENDPOINTS.unsubscribe, args)
	return res
}


// WEBPACK FOOTER //
// ./src/api/index.js